import React from "react";

// THIS IS THE MODIFIED VERSION OF visitorlist2
const Languageoptions = () => {
    return (
        <div className="languageSelection slide-in-left7">
 
            <div className="contentLanguage sideway">
                <button type="button" class="btnLangSpacing langBtn slide-in-right8">Bahasa Melayu</button>

                <button type="button" class="btnLangSpacing langBtn slide-in-right9">中文</button>

                <button type="button" class="btnLangSpacing langBtn slide-in-right10">தமிழ்</button>
            </div>

            <div className="langBg"></div>

        </div>
    );
};
export default Languageoptions